var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18659 11.4364C5.15214 11.5675 5.12278 11.7031 5.09344 11.8387C4.67952 13.7107 4.79424 15.6711 5.42495 17.5037C6.05566 19.3362 7.17786 20.9698 8.66783 22.2244C8.76994 22.3156 8.87206 22.4068 8.97417 22.498C9.07629 22.5892 9.18351 22.685 9.28051 22.7717C10.7697 24.0225 12.5671 24.8468 14.4755 25.1541C16.3839 25.4613 18.3294 25.2397 20.0985 24.5135L20.4718 24.3524C21.0166 24.0818 21.4345 23.6139 21.6422 23.0422C21.861 22.4671 21.8495 21.8258 21.6102 21.2494C21.3709 20.673 20.9219 20.2051 20.3548 19.9412C19.7969 19.6734 19.1625 19.6238 18.5787 19.8023C18.3988 19.8937 18.2134 19.9743 18.0235 20.0436C17.0884 20.4049 16.0678 20.5063 15.069 20.3371C14.0701 20.1679 13.1298 19.7343 12.3468 19.0819L12.0405 18.8083C11.9384 18.7171 11.8362 18.6259 11.729 18.5301C10.9542 17.8797 10.3652 17.0366 10.024 16.0894C9.68272 15.1422 9.60187 14.1259 9.78992 13.1477C9.81906 12.941 9.8632 12.737 9.92199 12.5373C9.97089 12.0173 9.85169 11.4919 9.58176 11.0376C9.37891 10.6989 9.09891 10.4117 8.76503 10.1999C8.43116 9.98811 8.05307 9.85789 7.6622 9.82006C7.27133 9.78222 6.87897 9.83787 6.51775 9.98236C6.15654 10.1269 5.8369 10.356 5.58542 10.6508C5.41061 10.8888 5.27594 11.154 5.18659 11.4364Z",
    fill: "#939CA9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDefault);
export default __webpack_public_path__ + "static/media/Call_Default.a3678c369ff4194489f3582ad4ec0c2a.svg";
export { ForwardRef as ReactComponent };